"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarTheme = void 0;

var _abstracts = require("../../abstracts");

var avatarTheme = function avatarTheme(theme) {
  return {
    root: {
      fontWeight: 700,
      fontFamily: _abstracts.constants.lato,
      '&.xs': {
        fontSize: 10,
        lineHeight: 13,
        height: 24,
        width: 24
      },
      '&.sm': {
        fontSize: 15,
        lineHeight: 20,
        height: 36,
        width: 36
      },
      '&.md': {
        fontSize: 18,
        lineHeight: 24,
        height: 44,
        width: 44
      },
      '&.lg': {
        fontSize: 23,
        lineHeight: 31,
        height: 56,
        width: 56
      }
    },
    colorDefault: {
      backgroundColor: theme.palette.neutral.main
    }
  };
};

exports.avatarTheme = avatarTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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